import {NAME_EXP} from '../constants.js'

export const formatAddressInAdyenFormat = (address) => {
    return {
        city: address?.city || '',
        country: address?.countryCode || '',
        houseNumberOrName: address?.address2 || '',
        postalCode: address?.postalCode || '',
        stateOrProvince: address?.stateCode || '',
        street: address?.address1 || ''
    }
}

// remove unallowed characters from names
export const formatNames = (name) => {
    try {
        if (name) {
            return name.replace(NAME_EXP, '')
        }
    } catch (err) {
        console.error('[formatAddress] Failed to format name', err.message)
    }
    return name
}
